import { useTranslation } from 'react-i18next';

import { Box, forwardRef, Text, VStack } from '@bonusly/design-system';

import { SelectorOption } from '../../components/selector/selector-option';
import { SelectorBox, SelectorProps } from '../selector/selector-box';
import { useSelector } from '../selector/use-selector';

export const HashtagSelector = forwardRef<SelectorProps<string>, 'div'>(({ command, hash, items, query }, ref) => {
	const { t } = useTranslation('components');
	const { getOptionProps, getSelectorProps, selectedIndex } = useSelector({
		command,
		hash,
		items,
		ref,
	});

	if (!items.length) {
		return null;
	}

	return (
		<SelectorBox>
			<VStack spacing={0} align="stretch" {...getSelectorProps()}>
				{!query && (
					<Box p={2} color="text.softer" fontSize="sm" fontWeight="medium" lineHeight={5}>
						{t('rich_media.search_hashtags.help_text')}
					</Box>
				)}

				{!items.length && (
					<Box p={2} color="text.softer" fontSize="sm" fontWeight="medium" lineHeight={5}>
						{t('rich_media.no_results')}
					</Box>
				)}

				{items.map((hashtag, index) => (
					<SelectorOption isSelected={selectedIndex === index} key={hashtag} textAlign="left" {...getOptionProps(index)}>
						<Text fontSize="md" fontWeight="medium" lineHeight={6}>
							#{hashtag}
						</Text>
					</SelectorOption>
				))}
			</VStack>
		</SelectorBox>
	);
});
